import { supabase } from '../lib/supabase';

/**
 * Loads the caller's own plan/trial/usage summary via the get_account_usage()
 * Postgres function — it takes no parameters and always resolves auth.uid()
 * internally, so it can never return another user's data.
 */
export async function getAccountUsage() {
  try {
    const { data, error } = await supabase.rpc('get_account_usage');
    if (error) throw error;
    return { data: data?.[0] || null, error: null };
  } catch (error) {
    console.error('getAccountUsage error:', error);
    return { data: null, error };
  }
}
